<template>
  <v-select
    v-model="selectedCompanies"
    :label="label"
    :placeholder="placeholder"
    :items="companyList"
    item-value="id"
    item-text="name"
    chips
    clearable
    color="bluecolor"
    item-color="bluecolor"
    multiple
    prepend-icon="mdi-label-multiple-outline"
    sort-desc
    @change="$emit('set-companies', selectedCompanies)"
  >
    <!-- Affichage des sélections possibles -->
    <template v-slot:item="{ attrs, item, on }">
      <v-list-item
        v-bind="attrs"
        active-class="bluecolor elevation-4 white--text"
        class="mx-3 mb-2 v-sheet"
        elevation="0"
        v-on="on"
      >
        <v-list-item-content>
          <v-list-item-title
            v-text="item.name"
          />
        </v-list-item-content>

        <v-scale-transition>
          <v-list-item-icon
            v-if="attrs.inputValue"
            class="my-3"
          >
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
        </v-scale-transition>
      </v-list-item>
    </template>

    <!-- Affichage des labels sélectionnés -->
    <template v-slot:selection="{ attrs, item, select, selected }">
      <v-chip
        v-bind="attrs"
        :input-value="selected"
        close
        close-icon="mdi-close"
        label
        outlined
        color="bluecolor"
        @click="select"
        @click:close="remove(item)"
      >
        <strong>{{ item.name }}</strong>
      </v-chip>
    </template>
  </v-select>
</template>

<script>
  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'CompaniesFilter',

    /* Paramètres */
    props: {
      idCompany: {
        type: String,
        default: undefined,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        label: 'Entreprise(s) sélectionnée(s) pour affiner votre vue',
        placeholder: 'Toutes les entreprises',
        companyList: [],
        selectedCompanies: [],
      }
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      idCompany: function () {
        this.fetchCompanies()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchCompanies()
    },

    /* Fonctions internes */
    methods: {
      remove: function (item) {
        this.selectedCompanies.splice(this.selectedCompanies.indexOf(item), 1)
        this.selectedCompanies = [...this.selectedCompanies]
      },

      // Récupération de toutes les entreprises
      fetchCompanies: function () {
        this.$Auth.httpRequest('get', 'api/dashboard/admin/selectCompanies')
          .then((response) => {
            if (Array.isArray(response.data) || response.data.length > 0) {
              this.companyList = response.data
            } else {
              this.companyList = []
            }
          })
          .catch((/* error */) => {
            if (this.isAdmin) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
      },
    },
  }
</script>
